import PrimaryMenuItem from '../model/PrimaryMenuItem.js';
import SecondaryMenuItem from '../model/SecondaryMenuItem';
import TertiaryMenuItem from '../model/TertiaryMenuItem';

// 第一層
const chat = new PrimaryMenuItem('Chat', 'chat');

// 第二層
const onlineConsultant = new SecondaryMenuItem('OnlineConsultant');
const onlineService = new SecondaryMenuItem('OnlineService');
const QuickReplySetting = new SecondaryMenuItem('QuickReplySetting', () => import('@/modules/qrs/views/List.vue'));
const ChannelSetting = new SecondaryMenuItem('ChannelSetting', () => import('@/modules/channel/views/Edit.vue'));
const CloudShopSharing = new SecondaryMenuItem('CloudShopSharing', () => import('@/modules/cloudshop/views/CloudShopSharing.vue'));
const MarketingPitch = new SecondaryMenuItem('MarketingPitch', () => import('@/modules/marketingPitch/views/MarketingPitch.vue'));

// 註冊第二層
chat.RegisterChild(onlineConsultant);
chat.RegisterChild(onlineService);
chat.RegisterChild(QuickReplySetting);
chat.RegisterChild(ChannelSetting);
chat.RegisterChild(CloudShopSharing);
chat.RegisterChild(MarketingPitch);

// 第三層
const consultantServicechat = new TertiaryMenuItem('ConsultantServicechat', () => import('@/modules/mcs/views/mcs.vue'));
const customerServiceChat = new TertiaryMenuItem('CustomerServiceChat', () => import('@/modules/mcs/views/customerMcs.vue'));
const ConsultantSetting = new TertiaryMenuItem('ConsultantSetting', () => import('@/modules/agentservice/views/consultantList.vue'));
const GroupSetting = new TertiaryMenuItem('GroupSetting', () => import('@/modules/gss/views/List.vue'));
const AgentServiceSetting = new TertiaryMenuItem('AgentServiceSetting', () => import('@/modules/agentservice/views/agentList.vue'));
const AgentParameterSetting = new TertiaryMenuItem('AgentParameterSetting', () => import('@/modules/gss/views/AgentParameterSetting.vue'));

// 註冊第三層
onlineConsultant.RegisterChild(consultantServicechat);
onlineConsultant.RegisterChild(ConsultantSetting);
onlineConsultant.RegisterChild(GroupSetting);
onlineService.RegisterChild(customerServiceChat);
onlineService.RegisterChild(AgentServiceSetting);
onlineService.RegisterChild(AgentParameterSetting);

export default chat;
